// extracted by mini-css-extract-plugin
module.exports = {"bar":"RateBar_bar__2RFOx"};